import { createFileRoute } from "@tanstack/react-router";
import PastTraumaResurfacing from "@/pages/PastTraumaResurfacing";
export const Route = createFileRoute("/when-past-trauma-resurfaces")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "When Past Trauma Resurfaces | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "When past trauma resurfaces as depression, SAINT® TMS and therapy can help. Treatment options for trauma-related depression in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "When Past Trauma Resurfaces | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "When past trauma resurfaces as depression, SAINT® TMS and therapy can help. Treatment options for trauma-related depression in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/when-past-trauma-resurfaces",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/when-past-trauma-resurfaces",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <PastTraumaResurfacing />;
}
